import i18next from 'i18next';
import React, { useRef, useEffect } from 'react';

import { Button, Tooltip } from '@commons/utils/styledLibraryComponents';
import { Container, Form, TextArea, TextAreaWrapper } from './styledComponents';

// Keep in sync with the backend cap (MAX_MESSAGE_CONTENT_LENGTH in inpulse-agent-api).
// The backend enforces it with a 422; this is the UX-side guard.
const MAX_MESSAGE_LENGTH = 2000;

const InputArea = (props) => {
  const {
    inputValue,
    setInputValue,
    sendMessage,
    isAiTyping,
    isMessagesLoading,
    isConversationLoading,
    dailyUsage,
    isRetryInProgress,
  } = props;

  const isCreditsLimitReached = dailyUsage === 100;
  const isOverLimit = (inputValue || '').length > MAX_MESSAGE_LENGTH;

  const handleSubmit = () => {
    if (isCreditsLimitReached || isRetryInProgress || isOverLimit) {
      return;
    }
    sendMessage();
  };

  // Reason surfaced in the send button tooltip when the button is disabled by a limit.
  const getDisabledReason = () => {
    if (isCreditsLimitReached) {
      return i18next.t('AGENT.AGENT.CREDITS_LIMIT_REACHED');
    }
    if (isOverLimit) {
      return i18next.t('AGENT.AGENT.MESSAGE_TOO_LONG', { max: MAX_MESSAGE_LENGTH });
    }
    return '';
  };

  const textAreaRef = useRef(null);

  useEffect(() => {
    if (textAreaRef.current) {
      textAreaRef.current.style.height = 'auto';
      textAreaRef.current.style.height = textAreaRef.current.scrollHeight + 'px';
      textAreaRef.current.style.maxHeight = '200px';
    }
  }, [inputValue]);

  return (
    <Container>
      <Form>
        <TextAreaWrapper>
          <TextArea
            placeholder={i18next.t('AGENT.AGENT.INPUT_AREA_PLACEHOLDER')}
            ref={textAreaRef}
            rows={1}
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && !e.shiftKey) {
                e.preventDefault();
                if (
                  isCreditsLimitReached ||
                  isRetryInProgress ||
                  isAiTyping ||
                  isOverLimit ||
                  e.target.value.trim() === ''
                ) {
                  return;
                }
                sendMessage();
              }
            }}
          />
        </TextAreaWrapper>
        <Tooltip
          renderTooltipTrigger={() => (
            <Button
              buttonCustomStyle={{
                minWidth: '40px',
              }}
              color={'inpulse-default'}
              handleClick={handleSubmit}
              icon={'/images/inpulse/send-white-small.svg'}
              isDisabled={
                isAiTyping ||
                !(inputValue || '').trim() ||
                isMessagesLoading ||
                isConversationLoading ||
                isCreditsLimitReached ||
                isRetryInProgress ||
                isOverLimit
              }
            />
          )}
          text={getDisabledReason()}
        />
      </Form>
    </Container>
  );
};

export default InputArea;
